import React from "react"

export const clock = ({ style }) => (
  <svg
    style={style}
    width="49px"
    height="46px"
    viewBox="0 0 49 46"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-73.000000, -288.000000)">
        <g id="Group-18-Copy-3" transform="translate(73.000000, 289.000000)">
          <ellipse
            id="Oval-12"
            fill="#B6BFF3"
            cx="22"
            cy="23.5"
            rx="22"
            ry="21.5"
          />
          <g
            id="Group-23"
            transform="translate(15.000000, 15.000000)"
            stroke="#9192C5"
            strokeWidth="4"
            strokeLinecap="round">
            <path
              d="M14,4 L14,12"
              id="Line"
              transform="translate(14.000000, 8.000000) scale(1, -1) rotate(-45.000000) translate(-14.000000, -8.000000) "
            />
            <path
              d="M-0.48959236,6.01040764 L12.5104076,6.01040764"
              id="Line"
              transform="translate(6.010408, 6.010408) scale(1, -1) rotate(-45.000000) translate(-6.010408, -6.010408) "
            />
          </g>
          <g
            id="clock"
            transform="translate(4.000000, 0.000000)"
            stroke="#222232"
            strokeWidth="2">
            <path
              d="M26.4617559,18.0035425 L26.4617559,26.6035425"
              id="Line"
              strokeLinecap="round"
              transform="translate(26.461756, 22.303543) scale(1, -1) rotate(-45.000000) translate(-26.461756, -22.303543) "
            />
            <path
              d="M10.6034384,19.7667597 L24.6834384,19.7667597"
              id="Line"
              strokeLinecap="round"
              transform="translate(17.643438, 19.766760) scale(1, -1) rotate(-45.000000) translate(-17.643438, -19.766760) "
            />
            <ellipse id="Oval-8" cx="22" cy="21.5" rx="22" ry="21.5" />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const autoMessages = ({ style }) => (
  <svg
    style={style}
    width="64px"
    height="49px"
    viewBox="0 0 64 49"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-141.000000, -289.000000)">
        <g id="Group-22" transform="translate(141.000000, 290.000000)">
          <ellipse
            id="Oval-11"
            fill="#9192C5"
            cx="20.5"
            cy="19"
            rx="20.5"
            ry="18"
          />
          <path
            d="M11.9995947,40 L18.022421,36.0761035 C20.058443,36.6878675 22.2363762,37.0191304 24.5,37.0191304 C35.8218374,37.0191304 45,28.7321158 45,18.5095652 C45,8.28701461 35.8218374,0 24.5,0 C22.9753566,0 21.4895874,0.150279875 20.059871,0.435329014 C16.0319188,1.2384004 12.44887,3.11116611 9.69486511,5.70678375 C8.76116213,6.58678796 7.92275315,7.54988 7.19460818,8.58254336 C5.17184446,11.4512496 4,14.8568452 4,18.5095652 C4,24.0337041 6.68019502,28.9926303 10.9305199,32.3840599"
            id="Combined-Shape"
            stroke="#222232"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <ellipse
            id="Oval-11"
            fill="#B6BFF3"
            cx="39.5"
            cy="25"
            rx="20.5"
            ry="18"
          />
          <path
            d="M29.9995947,47 L36.022421,43.0761035 C38.058443,43.6878675 40.2363762,44.0191304 42.5,44.0191304 C53.8218374,44.0191304 63,35.7321158 63,25.5095652 C63,15.2870146 53.8218374,7 42.5,7 C40.9753566,7 39.4895874,7.15027988 38.059871,7.43532901 C34.0319188,8.2384004 30.44887,10.1111661 27.6948651,12.7067838 C26.7611621,13.586788 25.9227532,14.54988 25.1946082,15.5825434 C23.1718445,18.4512496 22,21.8568452 22,25.5095652 C22,31.0337041 24.680195,35.9926303 28.9305199,39.3840599"
            id="Combined-Shape-Copy-2"
            stroke="#222232"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            transform="translate(42.500000, 27.000000) scale(-1, 1) translate(-42.500000, -27.000000) "
          />
        </g>
      </g>
    </g>
  </svg>
)

export const settings = ({ style }) => (
  <svg
    style={style}
    width="52px"
    height="50px"
    viewBox="0 0 52 50"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-224.000000, -289.000000)">
        <g
          id="Group-36"
          transform="translate(249.233495, 315.018982) rotate(-330.000000) translate(-249.233495, -315.018982) translate(225.233495, 290.018982)">
          <path
            d="M11.8426851,10.4514068 C12.9164539,9.68545901 14.0717327,9.02457347 15.2931701,8.48395323 L16.180869,4.73613063 L16.180869,4.73613063 C16.3945235,3.83409169 17.2000265,3.19709129 18.127023,3.19709129 L28.4232067,3.19709129 L28.4232067,3.19709129 C29.3502032,3.19709129 30.1557063,3.83409169 30.3693607,4.73613063 L31.2570596,8.48395323 C32.4784971,9.02457347 33.6337759,9.68545901 34.7075447,10.4514068 L38.4743647,9.3231232 C39.3623806,9.05713391 40.3167907,9.4362198 40.7802889,10.2390223 L45.9283808,19.155779 C46.391879,19.9585815 46.242972,20.9746678 45.5686106,21.6107174 L42.7604648,24.2593272 C42.8243527,24.8968779 42.8570624,25.543511 42.8570624,26.19771 C42.8570624,26.851909 42.8243527,27.4985421 42.7604648,28.1360928 L45.5686106,30.7847026 C46.242972,31.4207522 46.391879,32.4368385 45.9283808,33.239641 L40.7802889,42.1563977 C40.3167907,42.9592002 39.3623806,43.3382861 38.4743647,43.0722968 L34.7075447,41.9440132 C33.6337759,42.709961 32.4784971,43.3708465 31.2570596,43.9114668 L30.3693607,47.6592894 C30.1557063,48.5613283 29.3502032,49.1983287 28.4232067,49.1983287 L18.127023,49.1983287 C17.2000265,49.1983287 16.3945235,48.5613283 16.180869,47.6592894 L15.2931701,43.9114668 C14.0717327,43.3708465 12.9164539,42.709961 11.8426851,41.9440132 L8.075865,43.0722968 C7.18784914,43.3382861 6.23343909,42.9592002 5.76994085,42.1563977 L0.621848984,33.239641 C0.158350745,32.4368385 0.307257758,31.4207522 0.981619166,30.7847026 L3.789765,28.1360928 C3.72587701,27.4985421 3.69316737,26.851909 3.69316737,26.19771 C3.69316737,25.543511 3.72587701,24.8968779 3.789765,24.2593272 L0.981619166,21.6107174 C0.307257758,20.9746678 0.158350745,19.9585815 0.621848984,19.155779 L5.76994085,10.2390223 L5.76994085,10.2390223 C6.23343909,9.4362198 7.18784914,9.05713391 8.075865,9.3231232 L8.075865,9.3231232 L11.8426851,10.4514068 Z M23.2751149,40.1784782 C31.0718391,40.1784782 37.3923328,33.9190751 37.3923328,26.19771 C37.3923328,18.4763449 31.0718391,12.2169418 23.2751149,12.2169418 C15.4783907,12.2169418 9.1578969,18.4763449 9.1578969,26.19771 C9.1578969,33.9190751 15.4783907,40.1784782 23.2751149,40.1784782 Z"
            id="Combined-Shape"
            fill="#B6BFF3"
          />
          <path
            d="M13.5682427,7.25431554 C14.6420115,6.48836771 15.7972903,5.82748218 17.0187277,5.28686194 L17.9064267,1.53903934 L17.9064267,1.53903934 C18.1200811,0.637000403 18.9255842,-1.14182685e-13 19.8525806,-1.14352972e-13 L19.8525806,-1.13686838e-13 L30.1487644,-1.13686838e-13 C31.0757609,-1.13033786e-13 31.8812639,0.637000403 32.0949183,1.53903934 L32.9826173,5.28686194 C34.2040547,5.82748218 35.3593335,6.48836771 36.4331023,7.25431554 L40.1999224,6.1260319 L40.1999224,6.1260319 C41.0879382,5.86004262 42.0423483,6.23912851 42.5058465,7.04193101 L42.5058465,7.04193101 L47.6539384,15.9586877 C48.1174366,16.7614902 47.9685296,17.7775765 47.2941682,18.4136261 L44.4860224,21.0622359 C44.5499104,21.6997866 44.58262,22.3464197 44.58262,23.0006187 C44.58262,23.6548177 44.5499104,24.3014508 44.4860224,24.9390015 L47.2941682,27.5876113 C47.9685296,28.2236609 48.1174366,29.2397472 47.6539384,30.0425497 L47.6539384,30.0425497 L42.5058465,38.9593064 C42.0423483,39.7621089 41.0879382,40.1411948 40.1999224,39.8752055 L36.4331023,38.7469219 C35.3593335,39.5128697 34.2040547,40.1737552 32.9826173,40.7143755 L32.0949183,44.4621981 C31.8812639,45.364237 31.0757609,46.0012374 30.1487644,46.0012374 L19.8525806,46.0012374 C18.9255842,46.0012374 18.1200811,45.364237 17.9064267,44.4621981 L17.0187277,40.7143755 C15.7972903,40.1737552 14.6420115,39.5128697 13.5682427,38.7469219 L9.80142263,39.8752055 C8.91340677,40.1411948 7.95899672,39.7621089 7.49549848,38.9593064 L2.34740661,30.0425497 C1.88390837,29.2397472 2.03281538,28.2236609 2.70717679,27.5876113 L2.70717679,27.5876113 L5.51532263,24.9390015 C5.45143464,24.3014508 5.41872499,23.6548177 5.41872499,23.0006187 C5.41872499,22.3464197 5.45143464,21.6997866 5.51532263,21.0622359 L2.70717679,18.4136261 C2.03281538,17.7775765 1.88390837,16.7614902 2.34740661,15.9586877 L7.49549848,7.04193101 L7.49549848,7.04193101 C7.95899672,6.23912851 8.91340677,5.86004262 9.80142263,6.1260319 L9.80142263,6.1260319 L13.5682427,7.25431554 Z M25.0006725,36.9813869 C32.7973967,36.9813869 39.1178905,30.7219838 39.1178905,23.0006187 C39.1178905,15.2792536 32.7973967,9.01985047 25.0006725,9.01985047 C17.2039483,9.01985047 10.8834545,15.2792536 10.8834545,23.0006187 C10.8834545,30.7219838 17.2039483,36.9813869 25.0006725,36.9813869 Z"
            id="Combined-Shape"
            stroke="#222232"
            strokeWidth="2"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const customize = ({ style }) => (
  <svg
    style={style}
    width="53px"
    height="33px"
    viewBox="0 0 53 33"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-296.000000, -299.000000)">
        <g id="Group-43" transform="translate(297.000000, 300.000000)">
          <path
            d="M49.1976919,23.3333333 L1.848333,23.3333333"
            id="Line-13-Copy-3"
            stroke="#B6BFF3"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M49.2419052,6.66666667 L1.86477783,6.66666667"
            id="Line-13-Copy-5"
            stroke="#B6BFF3"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M46.0136189,25.1734882 L20.9268977,25.1734882"
            id="Line-13-Copy-3"
            stroke="#222232"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M32,8.51335745 L7.21611053,8.51335745"
            id="Line-13-Copy-5"
            stroke="#222232"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <ellipse
            id="Oval-13-Copy-9"
            fill="#F7F7F9"
            cx="15.995913"
            cy="6.01709402"
            rx="6"
            ry="6.01709402"
          />
          <ellipse
            id="Oval-13-Copy-9"
            fill="#9192C5"
            cx="13.995913"
            cy="8.01709402"
            rx="6"
            ry="6.01709402"
          />
          <ellipse
            id="Oval-13-Copy-9"
            stroke="#222232"
            strokeWidth="2"
            cx="15.995913"
            cy="6.01709402"
            rx="6"
            ry="6.01709402"
          />
          <ellipse
            id="Oval-13-Copy-11"
            fill="#F7F7F9"
            cx="36.8989149"
            cy="23.6772247"
            rx="6"
            ry="6.01709402"
          />
          <ellipse
            id="Oval-13-Copy-11"
            fill="#9192C5"
            cx="34.8989149"
            cy="25.6772247"
            rx="6"
            ry="6.01709402"
          />
          <ellipse
            id="Oval-13-Copy-11"
            stroke="#222232"
            strokeWidth="2"
            cx="36.8989149"
            cy="23.6772247"
            rx="6"
            ry="6.01709402"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const channels = ({ style }) => (
  <svg
    style={style}
    width="67px"
    height="49px"
    viewBox="0 0 67 49"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-375.000000, -290.000000)">
        <g id="Group-17" transform="translate(374.000000, 288.000000)">
          <text
            id="#"
            font-family="Rubik-Bold, Rubik"
            font-size="18"
            font-weight="bold"
            line-spacing="18"
            fill="#9192C5">
            <tspan x="0.5" y="17">
              #
            </tspan>
          </text>
          <text
            id="#"
            font-family="Rubik-Bold, Rubik"
            font-size="18"
            font-weight="bold"
            line-spacing="18"
            fill="#222232">
            <tspan x="1.5" y="17">
              #
            </tspan>
          </text>
          <path
            d="M20.5,9 L47.0188612,9"
            id="Line-15"
            stroke="#9192C5"
            strokeWidth="8"
            strokeLinecap="round"
          />
          <path
            d="M21.5,12.5 L40.5,12.5"
            id="Line-16"
            stroke="#222232"
            strokeLinecap="round"
          />
          <text
            id="#-copy-2"
            font-family="Rubik-Bold, Rubik"
            font-size="18"
            font-weight="bold"
            line-spacing="18"
            fill="#EBECEF">
            <tspan x="0.5" y="53">
              #
            </tspan>
          </text>
          <text
            id="#-copy-2"
            font-family="Rubik-Bold, Rubik"
            font-size="18"
            font-weight="bold"
            line-spacing="18"
            fill="#9192C5">
            <tspan x="1.5" y="53">
              #
            </tspan>
          </text>
          <path
            d="M20.5,45 L55,45"
            id="Line-15-Copy-2"
            stroke="#B6BFF3"
            strokeWidth="8"
            strokeLinecap="round"
          />
          <path
            d="M21.5,48.5 L40.5,48.5"
            id="Line-16-Copy"
            stroke="#222232"
            strokeLinecap="round"
          />
          <text
            id="#-copy"
            font-family="Rubik-Bold, Rubik"
            font-size="18"
            font-weight="bold"
            line-spacing="18"
            fill="#EBECEF">
            <tspan x="0.5" y="35">
              #
            </tspan>
          </text>
          <text
            id="#-copy"
            font-family="Rubik-Bold, Rubik"
            font-size="18"
            font-weight="bold"
            line-spacing="18"
            fill="#9192C5">
            <tspan x="1.5" y="35">
              #
            </tspan>
          </text>
          <path
            d="M20.5,27 L64,27"
            id="Line-15-Copy-3"
            stroke="#B6BFF3"
            strokeWidth="8"
            strokeLinecap="round"
          />
          <path
            d="M21.5,30.5 L56.5142828,30.5"
            id="Line-16-Copy-2"
            stroke="#222232"
            strokeLinecap="round"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const analytics = ({ style }) => (
  <svg
    style={style}
    width="57px"
    height="37px"
    viewBox="0 0 57 37"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <defs>
      <rect id="path-1" x="0" y="0" width="50" height="30" rx="3" />
    </defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-450.000000, -300.000000)">
        <g id="Group-49" transform="translate(450.000000, 302.000000)">
          <rect
            id="Rectangle-46-Copy"
            fill="#9192C5"
            x="0"
            y="2"
            width="52"
            height="33"
            rx="3"
          />
          <g id="Path-4" transform="translate(5.000000, 0.000000)">
            <mask id="mask-2" fill="white">
              <use xlinkHref="#path-1" />
            </mask>
            <g id="Mask">
              <use fill="#F7F7F9" fillRule="evenodd" xlinkHref="#path-1" />
              <rect
                stroke="#222232"
                strokeWidth="2"
                x="-1"
                y="-1"
                width="52"
                height="32"
                rx="3"
              />
            </g>
            <path
              d="M-0.0354848548,27.4543128 L6.48604047,15.9520492 L6.48604047,15.9520492 C7.03083322,14.9911774 8.25141551,14.6538787 9.21228732,15.1986714 C9.2169643,15.2013232 9.22163057,15.2039938 9.22628601,15.2066831 L13.9878913,17.9573855 L13.9878913,17.9573855 C15.5105636,18.8370087 17.4291289,18.6190236 18.7156531,17.4202227 L25.7840854,10.8337605 L25.7840854,10.8337605 C26.3845987,10.2741941 27.2660393,10.1383489 28.0071635,10.4911459 L33.8274283,13.2617644 L33.8274283,13.2617644 C35.0537638,13.8455364 36.4925402,13.7671411 37.6481874,13.053581 L51.5971122,4.44074734 L51.5971122,28.4407473 L51.5971122,28.4407473 C51.5971122,29.5453168 50.7016817,30.4407473 49.5971122,30.4407473 L1.70432746,30.4407473 L1.70432746,30.4407473 C0.599757963,30.4407473 -0.295672538,29.5453168 -0.295672538,28.4407473 C-0.295672538,28.0949726 -0.206026927,27.7551044 -0.0354848548,27.4543128 Z"
              fill="#B6BFF3"
              mask="url(#mask-2)"
            />
          </g>
          <path
            d="M7.87137396,27.8238957 L14.5185876,19.4438253 L14.5185876,19.4438253 C14.761045,19.1381619 15.1591323,19.0014172 15.5382412,19.09357 L22.0267816,20.6707859 L22.0267816,20.6707859 C22.6236831,20.815879 23.254152,20.6786225 23.7367164,20.2985237 L31.4724202,14.2053865 L31.4724202,14.2053865 C31.6487632,14.0664874 31.8667117,13.9909601 32.0911884,13.9909601 L41.4689714,13.9909601 L41.4689714,13.9909601 C42.0131639,13.9909601 42.5338596,13.769206 42.9109545,13.3768478 L50.9684127,4.99325539"
            id="Path-4"
            stroke="#222232"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const message = ({ style }) => (
  <svg
    style={style}
    width="53px"
    height="33px"
    viewBox="0 0 53 33"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-524.000000, -300.000000)">
        <g id="Group-29" transform="translate(524.000000, 300.000000)">
          <rect
            id="Rectangle-46"
            fill="#9192C5"
            x="0"
            y="3"
            width="50"
            height="30"
            rx="3"
          />
          <rect
            id="Rectangle-46"
            fill="#F7F7F9"
            x="3"
            y="0"
            width="50"
            height="30"
            rx="3"
          />
          <path
            d="M11,9.44489025 L27.2620537,21.6018665 L27.2620537,21.6018665 C28.0032007,22.1559236 29.0276557,22.1292097 29.7389196,21.5372791 L45,8.83664952"
            id="Path-20-Copy"
            stroke="#9192C5"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            transform="translate(28.000000, 15.418325) scale(1, -1) translate(-28.000000, -15.418325) "
          />
          <path
            d="M12,7.22352328 L26.7820124,16.8010869 L26.7820124,16.8010869 C27.4669224,17.2448539 28.3527594,17.2279623 29.0202537,16.7584069 L50,2"
            id="Path-20"
            stroke="#222232"
            strokeWidth="2"
            fill="#F7F7F9"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            id="Rectangle-46"
            stroke="#222232"
            strokeWidth="2"
            x="4"
            y="1"
            width="48"
            height="28"
            rx="3"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const install = ({ style }) => (
  <svg
    style={style}
    width="56px"
    height="46px"
    viewBox="0 0 56 46"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-597.000000, -296.000000)">
        <g id="Group-4" transform="translate(597.000000, 296.000000)">
          <path
            d="M15.9974211,34 C12.5202958,34 10.6761942,34 10.4651163,34 C4.68539215,34 0,29.4333044 0,23.8 C0,18.5446844 4.07771713,14.2176433 9.31754155,13.6606241 C9.30743571,13.4527649 9.30232558,13.2436307 9.30232558,13.0333333 C9.30232558,5.83522209 15.2892156,0 22.6744186,0 C30.0596217,0 36.0465116,5.83522209 36.0465116,13.0333333 C36.0465116,13.2231978 36.0423463,13.4121141 36.0340998,13.6 L39.5348837,13.6 C45.3146078,13.6 50,18.1666956 50,23.8 C50,29.4333044 45.3146078,34 39.5348837,34 L32.5970609,34"
            id="Combined-Shape"
            fill="#B6BFF3"
          />
          <path
            d="M16.4651163,33 L38.5970609,33 L45.5348837,33 C50.7679844,33 55,28.8751954 55,23.8 C55,18.7248046 50.7679844,14.6 45.5348837,14.6 L40.9892461,14.6 L41.0350616,13.5561513 C41.0426876,13.3824019 41.0465116,13.2081052 41.0465116,13.0333333 C41.0465116,6.39333111 35.5129982,1 28.6744186,1 C21.835839,1 16.3023256,6.39333111 16.3023256,13.0333333 C16.3023256,13.2268598 16.3070143,13.4198024 16.3163618,13.6120629 L16.362216,14.5552046 L15.4232508,14.6550212 C10.6463897,15.1628251 7,19.1008001 7,23.8 C7,28.8751954 11.2320156,33 16.4651163,33 Z"
            id="Combined-Shape"
            stroke="#222232"
            strokeWidth="2"
          />
          <g
            id="forward"
            transform="translate(29.500000, 37.000000) rotate(-270.000000) translate(-29.500000, -37.000000) translate(21.000000, 30.000000)"
            strokeLinecap="round"
            stroke="#222232">
            <g
              id="Group"
              transform="translate(8.925000, 7.000000) scale(-1, 1) translate(-8.925000, -7.000000) translate(1.700000, 0.000000)">
              <path
                d="M3.60624458,5.4623106 L3.60624458,14.2123106"
                id="Line-Copy"
                strokeWidth="2"
                transform="translate(3.606245, 9.837311) rotate(-225.000000) translate(-3.606245, -9.837311) "
              />
              <path
                d="M-0.643755416,3.7123106 L7.85624458,3.7123106"
                id="Line-Copy-2"
                strokeWidth="2"
                transform="translate(3.606245, 3.712311) rotate(-225.000000) translate(-3.606245, -3.712311) "
              />
              <path d="M1.7,7 L14.45,7" id="Line-7-Copy" strokeWidth="2" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const unlimited = ({ style }) => (
  <svg
    style={style}
    width="50px"
    height="30px"
    viewBox="0 0 50 30"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-671.000000, -300.000000)">
        <g id="Group-41-Copy" transform="translate(671.000000, 301.000000)">
          <path
            d="M5.47058824,27.1261261 C3.62744176,25.8768706 2.25490647,24.2665264 1.35294118,22.295045 C0.450975882,20.3235637 0,18.2252364 0,16 C0,13.7747636 0.450975882,11.6764363 1.35294118,9.70495495 C2.25490647,7.73347363 3.62744176,6.12312937 5.47058824,4.87387387 C7.31373471,3.62461838 9.56861412,3 12.2352941,3 C14.5882471,3 16.6176385,3.61485872 18.3235294,4.84459459 C20.0294203,6.07433047 21.7646971,7.82131 23.5294118,10.0855856 C25.2549106,7.86034923 26.9705797,6.12312937 28.6764706,4.87387387 C30.3823615,3.62461838 32.3921453,3 34.7058824,3 C37.4117782,3 39.6862653,3.62461838 41.5294118,4.87387387 C43.3725582,6.12312937 44.7450935,7.73347363 45.6470588,9.70495495 C46.5490241,11.6764363 47,13.7747636 47,16 C47,18.2252364 46.5490241,20.3235637 45.6470588,22.295045 C44.7450935,24.2665264 43.3725582,25.8768706 41.5294118,27.1261261 C39.6862653,28.3753816 37.4313859,29 34.7647059,29 C32.4117529,29 30.3725576,28.3949009 28.6470588,27.1846847 C26.92156,25.9744684 25.1960871,24.2762872 23.4705882,22.0900901 C21.7843053,24.2762872 20.07844,25.9744684 18.3529412,27.1846847 C16.6274424,28.3949009 14.5882471,29 12.2352941,29 C9.56861412,29 7.31373471,28.3753816 5.47058824,27.1261261 Z M16.2941176,19.8648649 C17.50981,18.6156094 18.4313694,17.3663726 19.0588235,16.1171171 C18.3529376,14.7897832 17.4019668,13.4819884 16.2058824,12.1936937 C15.0097979,10.905399 13.7451047,10.2612613 12.4117647,10.2612613 C11.0784247,10.2612613 9.93137735,10.7785234 8.97058824,11.8130631 C8.00979912,12.8476028 7.52941176,14.2432345 7.52941176,16 C7.52941176,17.7567655 8.00979912,19.1523972 8.97058824,20.1869369 C9.93137735,21.2214766 11.0784247,21.7387387 12.4117647,21.7387387 C13.7843206,21.7387387 15.0784253,21.1141204 16.2941176,19.8648649 Z M37.9705882,20.1869369 C38.9313774,19.1523972 39.4117647,17.7567655 39.4117647,16 C39.4117647,14.2432345 38.9313774,12.8476028 37.9705882,11.8130631 C37.0097991,10.7785234 35.8823594,10.2612613 34.5882353,10.2612613 C33.2156794,10.2612613 31.9117709,10.9151586 30.6764706,12.222973 C29.4411703,13.5307873 28.5098071,14.8288224 27.8823529,16.1171171 C28.5490229,17.3663726 29.49019,18.6156094 30.7058824,19.8648649 C31.9215747,21.1141204 33.2156794,21.7387387 34.5882353,21.7387387 C35.8823594,21.7387387 37.0097991,21.2214766 37.9705882,20.1869369 Z"
            id="∞"
            fill="#9192C5"
          />
          <path
            d="M7.47058824,24.1261261 C5.62744176,22.8768706 4.25490647,21.2665264 3.35294118,19.295045 C2.45097588,17.3235637 2,15.2252364 2,13 C2,10.7747636 2.45097588,8.67643628 3.35294118,6.70495495 C4.25490647,4.73347363 5.62744176,3.12312937 7.47058824,1.87387387 C9.31373471,0.624618378 11.5686141,0 14.2352941,0 C16.5882471,0 18.6176385,0.614858716 20.3235294,1.84459459 C22.0294203,3.07433047 23.7646971,4.82131 25.5294118,7.08558559 C27.2549106,4.86034923 28.9705797,3.12312937 30.6764706,1.87387387 C32.3823615,0.624618378 34.3921453,0 36.7058824,0 C39.4117782,0 41.6862653,0.624618378 43.5294118,1.87387387 C45.3725582,3.12312937 46.7450935,4.73347363 47.6470588,6.70495495 C48.5490241,8.67643628 49,10.7747636 49,13 C49,15.2252364 48.5490241,17.3235637 47.6470588,19.295045 C46.7450935,21.2665264 45.3725582,22.8768706 43.5294118,24.1261261 C41.6862653,25.3753816 39.4313859,26 36.7647059,26 C34.4117529,26 32.3725576,25.3949009 30.6470588,24.1846847 C28.92156,22.9744684 27.1960871,21.2762872 25.4705882,19.0900901 C23.7843053,21.2762872 22.07844,22.9744684 20.3529412,24.1846847 C18.6274424,25.3949009 16.5882471,26 14.2352941,26 C11.5686141,26 9.31373471,25.3753816 7.47058824,24.1261261 Z M18.2941176,16.8648649 C19.50981,15.6156094 20.4313694,14.3663726 21.0588235,13.1171171 C20.3529376,11.7897832 19.4019668,10.4819884 18.2058824,9.19369369 C17.0097979,7.90539896 15.7451047,7.26126126 14.4117647,7.26126126 C13.0784247,7.26126126 11.9313774,7.77852336 10.9705882,8.81306306 C10.0097991,9.84760277 9.52941176,11.2432345 9.52941176,13 C9.52941176,14.7567655 10.0097991,16.1523972 10.9705882,17.1869369 C11.9313774,18.2214766 13.0784247,18.7387387 14.4117647,18.7387387 C15.7843206,18.7387387 17.0784253,18.1141204 18.2941176,16.8648649 Z M39.9705882,17.1869369 C40.9313774,16.1523972 41.4117647,14.7567655 41.4117647,13 C41.4117647,11.2432345 40.9313774,9.84760277 39.9705882,8.81306306 C39.0097991,7.77852336 37.8823594,7.26126126 36.5882353,7.26126126 C35.2156794,7.26126126 33.9117709,7.91515863 32.6764706,9.22297297 C31.4411703,10.5307873 30.5098071,11.8288224 29.8823529,13.1171171 C30.5490229,14.3663726 31.49019,15.6156094 32.7058824,16.8648649 C33.9215747,18.1141204 35.2156794,18.7387387 36.5882353,18.7387387 C37.8823594,18.7387387 39.0097991,18.2214766 39.9705882,17.1869369 Z"
            id="∞"
            fill="#B6BFF3"
          />
          <path
            d="M7.47058824,24.1261261 C5.62744176,22.8768706 4.25490647,21.2665264 3.35294118,19.295045 C2.45097588,17.3235637 2,15.2252364 2,13 C2,10.7747636 2.45097588,8.67643628 3.35294118,6.70495495 C4.25490647,4.73347363 5.62744176,3.12312937 7.47058824,1.87387387 C9.31373471,0.624618378 11.5686141,0 14.2352941,0 C16.5882471,0 18.6176385,0.614858716 20.3235294,1.84459459 C22.0294203,3.07433047 23.7646971,4.82131 25.5294118,7.08558559 C27.2549106,4.86034923 28.9705797,3.12312937 30.6764706,1.87387387 C32.3823615,0.624618378 34.3921453,0 36.7058824,0 C39.4117782,0 41.6862653,0.624618378 43.5294118,1.87387387 C45.3725582,3.12312937 46.7450935,4.73347363 47.6470588,6.70495495 C48.5490241,8.67643628 49,10.7747636 49,13 C49,15.2252364 48.5490241,17.3235637 47.6470588,19.295045 C46.7450935,21.2665264 45.3725582,22.8768706 43.5294118,24.1261261 C41.6862653,25.3753816 39.4313859,26 36.7647059,26 C34.4117529,26 32.3725576,25.3949009 30.6470588,24.1846847 C28.92156,22.9744684 27.1960871,21.2762872 25.4705882,19.0900901 C23.7843053,21.2762872 22.07844,22.9744684 20.3529412,24.1846847 C18.6274424,25.3949009 16.5882471,26 14.2352941,26 C11.5686141,26 9.31373471,25.3753816 7.47058824,24.1261261 Z M18.2941176,16.8648649 C19.50981,15.6156094 20.4313694,14.3663726 21.0588235,13.1171171 C20.3529376,11.7897832 19.4019668,10.4819884 18.2058824,9.19369369 C17.0097979,7.90539896 15.7451047,7.26126126 14.4117647,7.26126126 C13.0784247,7.26126126 11.9313774,7.77852336 10.9705882,8.81306306 C10.0097991,9.84760277 9.52941176,11.2432345 9.52941176,13 C9.52941176,14.7567655 10.0097991,16.1523972 10.9705882,17.1869369 C11.9313774,18.2214766 13.0784247,18.7387387 14.4117647,18.7387387 C15.7843206,18.7387387 17.0784253,18.1141204 18.2941176,16.8648649 Z M39.9705882,17.1869369 C40.9313774,16.1523972 41.4117647,14.7567655 41.4117647,13 C41.4117647,11.2432345 40.9313774,9.84760277 39.9705882,8.81306306 C39.0097991,7.77852336 37.8823594,7.26126126 36.5882353,7.26126126 C35.2156794,7.26126126 33.9117709,7.91515863 32.6764706,9.22297297 C31.4411703,10.5307873 30.5098071,11.8288224 29.8823529,13.1171171 C30.5490229,14.3663726 31.49019,15.6156094 32.7058824,16.8648649 C33.9215747,18.1141204 35.2156794,18.7387387 36.5882353,18.7387387 C37.8823594,18.7387387 39.0097991,18.2214766 39.9705882,17.1869369 Z"
            id="∞"
            stroke="#222232"
            strokeWidth="2"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const slack = ({ style }) => (
  <svg
    style={style}
    width="42px"
    height="41px"
    viewBox="0 0 42 41"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-732.000000, -291.000000)"
        fillRule="nonzero">
        <g id="slack" transform="translate(732.880952, 290.475000)">
          <path
            d="M14.278351,20.1920678 L16.8776436,27.3923149 L24.6313901,24.842066 L22.0320975,17.6418189 L14.278351,20.1920678 Z M12.2863657,14.6741102 L20.0401122,12.1238613 L18.2574771,7.18582054 C17.7075971,5.66260929 18.5201388,3.98945809 20.0723398,3.44873274 C21.6245407,2.9080074 23.328614,3.70446959 23.878494,5.22768084 L25.6964171,10.2634722 L30.2005783,8.7820294 C31.7619798,8.26847606 33.4518934,9.09455712 33.9751059,10.6271331 C34.4983185,12.1597091 33.6567,13.8184247 32.0952985,14.331978 L27.6884024,15.7814298 L30.2876951,22.9816769 L34.6101584,21.5599954 C36.1715599,21.0464421 37.8614735,21.8725232 38.384686,23.4050992 C38.9078986,24.9376751 38.0662801,26.5963907 36.5048786,27.109944 L32.2796804,28.4996345 L33.797545,32.70424 C34.347425,34.2274512 33.5348833,35.9006024 31.9826823,36.4413278 C30.4304814,36.9820531 28.7264081,36.1855909 28.1765281,34.6623797 L26.6233755,30.3600236 L18.869629,32.9102725 L20.3800214,37.0941795 C20.9299014,38.6173907 20.1173597,40.2905419 18.5651587,40.8312673 C17.0129578,41.3719926 15.3088845,40.5755304 14.7590045,39.0523192 L13.213324,34.7706615 L8.33942171,36.3737142 C6.7780202,36.8872676 5.08810662,36.0611865 4.56489408,34.5286105 C4.04168155,32.9960345 4.88329999,31.337319 6.4447015,30.8237656 L11.2213387,29.252704 L8.62204608,22.0524569 L3.92984158,23.5957482 C2.36844007,24.1093015 0.678526493,23.2832205 0.155313954,21.7506445 C-0.367898584,20.2180685 0.473719864,18.5593529 2.03512137,18.0457996 L6.63006075,16.5344993 L4.83995351,11.57576 C4.29007352,10.0525488 5.1026152,8.37939759 6.65481616,7.83867224 C8.20701712,7.2979469 9.91109042,8.09440909 10.4609704,9.61762034 L12.2863657,14.6741102 Z"
            id="Combined-Shape"
            fill="#B6BFF3"
          />
          <path
            d="M16.738351,17.7320678 L19.3376436,24.9323149 L27.0913901,22.382066 L24.4920975,15.1818189 L16.738351,17.7320678 Z M14.7463657,12.2141102 L22.5001122,9.66386132 L20.7174771,4.72582054 C20.1675971,3.20260929 20.9801388,1.52945809 22.5323398,0.988732745 C24.0845407,0.448007399 25.788614,1.24446959 26.338494,2.76768084 L28.1564171,7.80347223 L32.6605783,6.3220294 C34.2219798,5.80847606 35.9118934,6.63455712 36.4351059,8.16713311 C36.9583185,9.6997091 36.1167,11.3584247 34.5552985,11.871978 L30.1484024,13.3214298 L32.7476951,20.5216769 L37.0701584,19.0999954 C38.6315599,18.5864421 40.3214735,19.4125232 40.844686,20.9450992 C41.3678986,22.4776751 40.5262801,24.1363907 38.9648786,24.649944 L34.7396804,26.0396345 L36.257545,30.24424 C36.807425,31.7674512 35.9948833,33.4406024 34.4426823,33.9813278 C32.8904814,34.5220531 31.1864081,33.7255909 30.6365281,32.2023797 L29.0833755,27.9000236 L21.329629,30.4502725 L22.8400214,34.6341795 C23.3899014,36.1573907 22.5773597,37.8305419 21.0251587,38.3712673 C19.4729578,38.9119926 17.7688845,38.1155304 17.2190045,36.5923192 L15.673324,32.3106615 L10.7994217,33.9137142 C9.2380202,34.4272676 7.54810662,33.6011865 7.02489408,32.0686105 C6.50168155,30.5360345 7.34329999,28.877319 8.9047015,28.3637656 L13.6813387,26.792704 L11.0820461,19.5924569 L6.38984158,21.1357482 C4.82844007,21.6493015 3.13852649,20.8232205 2.61531395,19.2906445 C2.09210142,17.7580685 2.93371986,16.0993529 4.49512137,15.5857996 L9.09006075,14.0744993 L7.29995351,9.11576004 C6.75007352,7.59254878 7.5626152,5.91939759 9.11481616,5.37867224 C10.6670171,4.8379469 12.3710904,5.63440909 12.9209704,7.15762034 L14.7463657,12.2141102 Z"
            id="Combined-Shape"
            fill="#2C2C46"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const smiley = ({ style }) => (
  <svg
    style={style}
    width="43px"
    height="41px"
    viewBox="0 0 43 41"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-787.000000, -293.000000)">
        <g id="Group-25" transform="translate(787.000000, 294.000000)">
          <ellipse
            id="Oval-12"
            fill="#B6BFF3"
            cx="19.5"
            cy="21"
            rx="19.5"
            ry="19"
          />
          <g
            id="smiley"
            transform="translate(4.000000, 0.000000)"
            stroke="#222232">
            <circle id="Oval-8-Copy-3" strokeWidth="2" cx="19" cy="19" r="19" />
            <g
              id="Group-15"
              strokeWidth="1"
              fillRule="evenodd"
              transform="translate(7.600000, 10.640000)">
              <path
                d="M11.4,21.28 C17.6960461,21.28 22.8,15.8357826 22.8,9.12 C22.8,9.12 17.1,12.0798257 11.4,12.0798257 C5.7,12.0798257 0,9.12 0,9.12 C0,15.8357826 5.10395385,21.28 11.4,21.28 Z"
                id="Oval-8-Copy-5"
                strokeWidth="2"
                strokeLinejoin="round"
              />
              <path
                d="M6.84,0 L6.84,3.04"
                id="Line-Copy-5"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M15.96,0 L15.96,3.04"
                id="Line-Copy-6"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const frowney = ({ style }) => (
  <svg
    style={style}
    width="43px"
    height="41px"
    viewBox="0 0 43 41"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-787.000000, -343.000000)">
        <g
          id="Group-25-Copy"
          transform="translate(808.000000, 364.000000) scale(1, -1) translate(-808.000000, -364.000000) translate(787.000000, 344.000000)">
          <ellipse
            id="Oval-12"
            fill="#FC8C9C"
            cx="19.5"
            cy="19"
            rx="19.5"
            ry="19"
          />
          <g
            id="smiley"
            transform="translate(4.000000, 2.000000)"
            stroke="#222232">
            <circle id="Oval-8-Copy-3" strokeWidth="2" cx="19" cy="19" r="19" />
            <g
              id="Group-15"
              strokeWidth="1"
              fillRule="evenodd"
              transform="translate(7.600000, 10.640000)">
              <path
                d="M11.4,21.28 C17.6960461,21.28 22.8,15.8357826 22.8,9.12 C22.8,9.12 17.1,12.0798257 11.4,12.0798257 C5.7,12.0798257 0,9.12 0,9.12 C0,15.8357826 5.10395385,21.28 11.4,21.28 Z"
                id="Oval-8-Copy-5"
                strokeWidth="2"
                strokeLinejoin="round"
              />
              <path
                d="M6.84,0 L6.84,3.04"
                id="Line-Copy-5"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M15.96,0 L15.96,3.04"
                id="Line-Copy-6"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const code = ({ style }) => (
  <svg
    style={style}
    width="43px"
    height="29px"
    viewBox="0 0 43 29"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round">
      <g
        id="icon-system"
        transform="translate(-843.000000, -299.000000)"
        stroke="#222232">
        <g id="code" transform="translate(843.000000, 298.000000)">
          <g
            id="check-copy-2"
            transform="translate(21.500000, 15.500000) rotate(-15.000000) translate(-21.500000, -15.500000) translate(13.437500, 2.695652)">
            <path
              d="M1.20869632,24.7443871 L14.6461963,1.39935452"
              id="Line"
              strokeWidth="2"
            />
          </g>
          <g
            id="back-copy-2"
            transform="translate(36.281250, 15.500000) scale(-1, 1) translate(-36.281250, -15.500000) translate(29.562500, 4.043478)">
            <path
              d="M6.71875,9.43478261 L6.71875,22.9130435"
              id="Line"
              strokeWidth="2"
              transform="translate(6.718750, 16.173913) rotate(-225.000000) translate(-6.718750, -16.173913) "
            />
            <path
              d="M0,6.73913043 L13.4375,6.73913043"
              id="Line"
              strokeWidth="2"
              transform="translate(6.718750, 6.739130) rotate(-225.000000) translate(-6.718750, -6.739130) "
            />
          </g>
          <g id="back-copy-2" transform="translate(0.000000, 4.043478)">
            <path
              d="M6.71875,9.43478261 L6.71875,22.9130435"
              id="Line"
              strokeWidth="2"
              transform="translate(6.718750, 16.173913) rotate(-225.000000) translate(-6.718750, -16.173913) "
            />
            <path
              d="M0,6.73913043 L13.4375,6.73913043"
              id="Line"
              strokeWidth="2"
              transform="translate(6.718750, 6.739130) rotate(-225.000000) translate(-6.718750, -6.739130) "
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const profile = ({ style }) => (
  <svg
    style={style}
    width="28px"
    height="34px"
    viewBox="0 0 28 34"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-896.000000, -296.000000)">
        <g id="Group-19-Copy" transform="translate(896.000000, 297.000000)">
          <path
            d="M18,7.5 C18,11.0898571 15.0898571,14 11.5,14 C7.91014286,14 5,11.0898571 5,7.5 C5,3.91014286 7.91014286,1 11.5,1 C15.0898571,1 18,3.91014286 18,7.5"
            id="Fill-1"
            fill="#B6BFF3"
          />
          <path
            d="M16.6189437,17.0772579 C15.2671861,17.9702138 13.6876883,18.4835137 12,18.4835137 C10.3122424,18.4835137 8.73281385,17.9702138 7.38105628,17.0772579 C7.24252814,16.9857041 7.07290043,16.9760265 6.924329,17.0455366 C2.85575758,18.9483485 0,23.4126672 0,28.6167124 L0,30.5347319 C0,31.8962862 0.995324675,33 2.22309957,33 L21.7769004,33 C23.0046753,33 24,31.8962862 24,30.5347319 L24,28.6167124 C24,23.4126672 21.1441732,18.9483485 17.0756017,17.0455366 C16.9270303,16.9760265 16.7574719,16.9857041 16.6189437,17.0772579 Z"
            id="Fill-3"
            fill="#B6BFF3"
          />
          <path
            d="M21,6.5 C21,10.0898571 18.0898571,13 14.5,13 C10.9101429,13 8,10.0898571 8,6.5 C8,2.91014286 10.9101429,0 14.5,0 C18.0898571,0 21,2.91014286 21,6.5"
            id="Fill-1"
            stroke="#222232"
            strokeWidth="2"
          />
          <path
            d="M19.6189437,16.0772579 C18.2671861,16.9702138 16.6876883,17.4835137 15,17.4835137 C13.3122424,17.4835137 11.7328139,16.9702138 10.3810563,16.0772579 C10.2425281,15.9857041 10.0729004,15.9760265 9.924329,16.0455366 C5.85575758,17.9483485 3,22.4126672 3,27.6167124 L3,29.5347319 C3,30.8962862 3.99532468,32 5.22309957,32 L24.7769004,32 C26.0046753,32 27,30.8962862 27,29.5347319 L27,27.6167124 C27,22.4126672 24.1441732,17.9483485 20.0756017,16.0455366 C19.9270303,15.9760265 19.7574719,15.9857041 19.6189437,16.0772579 Z"
            id="Fill-3"
            stroke="#222232"
            strokeWidth="2"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const website = ({ style }) => (
  <svg
    style={style}
    width="54px"
    height="42px"
    viewBox="0 0 54 42"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-930.000000, -292.000000)">
        <g id="Group-53" transform="translate(931.000000, 293.000000)">
          <g id="Group-32-Copy-2">
            <g
              id="Group-28-Copy"
              transform="translate(20.000000, 13.000000) scale(-1, 1) rotate(-180.000000) translate(-20.000000, -13.000000) ">
              <rect
                id="Rectangle-45"
                fill="#B6BFF3"
                x="2.5"
                y="3.55271368e-15"
                width="37.5"
                height="22.7272727"
                rx="3"
              />
              <path
                d="M8.8817842e-16,7.81818182 L8.8817842e-16,22.474076 L8.8817842e-16,22.474076 C1.82687564e-15,24.1309303 1.34314575,25.474076 3,25.474076 L30.7003701,25.474076"
                id="Path-19"
                stroke="#222232"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </g>
            <rect
              id="Rectangle-11"
              fill="#9192C5"
              x="11"
              y="6"
              width="23"
              height="4"
              rx="2"
            />
            <circle id="Oval-14" fill="#F7F7F9" cx="7" cy="8" r="2" />
          </g>
          <g id="Group-32-Copy-3" transform="translate(13.000000, 15.000000)">
            <g
              id="Group-28-Copy"
              transform="translate(20.000000, 13.000000) scale(-1, 1) rotate(-180.000000) translate(-20.000000, -13.000000) ">
              <rect
                id="Rectangle-45"
                fill="#B6BFF3"
                x="2.5"
                y="3.55271368e-15"
                width="37.5"
                height="22.7272727"
                rx="3"
              />
              <path
                d="M8.8817842e-16,7.81818182 L8.8817842e-16,22.474076 L8.8817842e-16,22.474076 C1.82687564e-15,24.1309303 1.34314575,25.474076 3,25.474076 L30.7003701,25.474076"
                id="Path-19"
                stroke="#222232"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M26.8580542,2.51515152 L26.8580542,11.3682479 L26.8580542,11.3682479 C26.8580542,13.0251021 28.2011999,14.3682479 29.8580542,14.3682479 L37.4503701,14.3682479"
                id="Path-19-Copy"
                stroke="#222232"
                strokeWidth="2"
                strokeLinecap="round"
                transform="translate(32.154212, 8.441700) scale(-1, -1) translate(-32.154212, -8.441700) "
              />
            </g>
            <rect
              id="Rectangle-11"
              fill="#9192C5"
              x="11"
              y="6"
              width="23"
              height="4"
              rx="2"
            />
            <circle id="Oval-14" fill="#F7F7F9" cx="7" cy="8" r="2" />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const world = ({ style }) => (
  <svg
    style={style}
    width="39px"
    height="38px"
    viewBox="0 0 39 38"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-1000.000000, -294.000000)">
        <g id="Icon-Outlines" transform="translate(41.000000, 61.000000)">
          <g id="Group-54" transform="translate(959.000000, 234.000000)">
            <g id="Group-5-Copy-3" transform="translate(0.000000, 1.000000)">
              <circle id="Oval-8" fill="#B6BFF3" cx="17.5" cy="18.5" r="17.5" />
              <g
                id="Group-2"
                transform="translate(3.600000, 0.000000)"
                fill="#F7F7F9">
                <path
                  d="M5.53134481,4.73453223 C5.53134481,4.73453223 6.53308172,6.55434628 8.06297702,6.06778519 C9.59287233,5.58122409 12.2282374,3.323399 13.6027152,5.59776366 C14.977193,7.87212831 13.3131506,7.49346927 11.0747714,11.321827 C10.2606929,12.7141664 11.9118964,15.7703733 11.5118702,17.939819 C11.4000984,18.5459863 10.3330245,18.4573907 9.80392046,18.2139801 C8.6284871,17.6732302 7.96185765,15.3542547 6.73519531,15.7423433 C4.5656244,16.4287472 5.58476889,23.4623073 7.51536227,23.6858732 C8.70050842,23.8231151 9.94620047,22.8080253 11.0747714,22.3961159 C17.0247716,20.2244653 12.8540777,27.3715295 12.9249989,28.4941378 C13.0016198,29.706965 15.1836328,31.2389786 14.4380244,33.3060085 C14.1665529,34.0586017 2.21239546,31.0887957 0.492079924,20.523539 C-1.22823561,9.95828232 5.53134481,4.73453223 5.53134481,4.73453223 Z"
                  id="Path-5"
                />
                <path
                  d="M23.6234283,0.342001884 C26.3710475,4.62231684 24.6784733,9.58781154 20.7110596,10.271618 C18.8064132,10.5998947 18.4162309,16.0379418 19.9237934,20.1842381 C21.093409,23.4010684 26.5149045,15.2242422 27.3244806,19.3127187 C28.3231594,24.3561911 18.9579767,27.1422259 26.211349,31.2 C26.211349,31.2 37.3266726,24.3684674 33.6498149,11.6636107 C29.9729571,-1.04124609 23.6234283,0.342001884 23.6234283,0.342001884 Z"
                  id="Path-6"
                />
              </g>
            </g>
            <g
              id="Group-5-Copy-3"
              transform="translate(3.000000, 0.000000)"
              stroke="#222232"
              strokeWidth="2">
              <circle id="Oval-8" cx="17.5" cy="17.5" r="17.5" />
              <g id="Group-2" transform="translate(5.600000, 0.000000)">
                <path
                  d="M-8.8817842e-16,6.03194913 C-8.8817842e-16,6.03194913 1.53308172,7.55434628 3.06297702,7.06778519 C4.59287233,6.58122409 7.22823739,4.323399 8.60271519,6.59776366 C9.97719299,8.87212831 8.31315064,8.49346927 6.07477138,12.321827 C5.26069285,13.7141664 6.91189641,16.7703733 6.51187018,18.939819 C6.4000984,19.5459863 5.33302447,19.4573907 4.80392046,19.2139801 C3.6284871,18.6732302 2.96185765,16.3542547 1.73519531,16.7423433 C-0.434375604,17.4287472 0.584768891,24.4623073 2.51536227,24.6858732 C3.70050842,24.8231151 4.94620047,23.8080253 6.07477138,23.3961159 C12.0247716,21.2244653 7.85407766,28.3715295 7.92499892,29.4941378 C8.00161979,30.706965 10.1836328,32.2389786 9.43802445,34.3060085"
                  id="Path-5"
                />
                <path
                  d="M18.6234283,1.34200188 C21.3710475,5.62231684 19.6784733,10.5878115 15.7110596,11.271618 C13.8064132,11.5998947 13.4162309,17.0379418 14.9237934,21.1842381 C16.093409,24.4010684 21.5149045,16.2242422 22.3244806,20.3127187 C23.3231594,25.3561911 13.9579767,28.1422259 21.211349,32.2"
                  id="Path-6"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const edit = ({ style }) => (
  <svg
    style={style}
    width="41px"
    height="38px"
    viewBox="0 0 41 38"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-1056.000000, -293.000000)">
        <g id="Group-30" transform="translate(1056.000000, 292.000000)">
          <ellipse
            id="Oval-11-Copy-2"
            fill="#B6BFF3"
            cx="17"
            cy="20.5"
            rx="17"
            ry="14.5"
          />
          <path
            d="M9.63381026,38 L14.6283491,34.8608828 C16.3167576,35.350294 18.1228485,35.6153043 20,35.6153043 C29.3888407,35.6153043 37,28.9856926 37,20.8076521 C37,12.6296117 29.3888407,6 20,6 C18.7356616,6 17.5035603,6.1202239 16.3179418,6.34826321 C12.9776887,6.99072032 10.00638,8.48893289 7.72257106,10.565427 C6.94828079,11.2694304 6.25301481,12.039904 5.64918727,12.8660347 C3.97177345,15.1609996 3,17.8854762 3,20.8076521 C3,25.2269633 5.22260074,29.1941043 8.74726043,31.9072479"
            id="Combined-Shape-Copy-5"
            stroke="#222232"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            transform="translate(20.000000, 22.000000) scale(-1, 1) translate(-20.000000, -22.000000) "
          />
          <path
            d="M28.0147643,0.188866509 L28.644017,0.137022328 L28.644017,0.137022328 C30.2952763,0.000974961316 31.7441746,1.22929689 31.880222,2.88055614 C31.8833867,2.91896787 31.8858109,2.95743701 31.8874933,2.99594216 L32.5483089,18.1205282 L29.6458368,23.1801076 L29.6458368,23.1801076 C29.3710218,23.6591641 28.7598882,23.8247346 28.2808317,23.5499196 C28.1333791,23.4653322 28.0099237,23.3445519 27.9221268,23.1989875 L25.8358942,19.7400805 L25.8358942,19.7400805 C25.45984,19.1165947 25.2610998,18.4022897 25.2610998,17.6741748 L25.2610998,3.17873587 L25.2610998,3.17873587 C25.2610998,1.61739049 26.4586914,0.317071466 28.0147643,0.188866509 Z"
            id="Rectangle-9"
            fill="#9192C5"
            transform="translate(28.904704, 11.904704) rotate(-315.000000) translate(-28.904704, -11.904704) "
          />
          <g
            id="pencil"
            transform="translate(19.000000, 0.000000)"
            stroke="#222232">
            <g
              id="Group-7-Copy"
              transform="translate(11.376163, 11.376163) rotate(-225.000000) translate(-11.376163, -11.376163) translate(-0.945265, 8.090449)">
              <rect
                id="Rectangle-19"
                strokeWidth="2"
                x="4.72693262"
                y="1"
                width="13.5288859"
                height="4.21155436"
              />
              <path
                d="M19.6388858,5.21155436 L22.9783408,3.24051124 C23.2695447,3.06863428 23.269714,3.10646103 22.9691888,2.92914171 L19.6996314,1 L3.10932042,1 C1.95260845,1 1.0124365,1.9426207 1.0124365,3.10577718 C1.0124365,4.26640055 1.95792999,5.21155436 3.12174158,5.21155436 L19.6388858,5.21155436 Z"
                id="Rectangle-19-Copy-2"
                strokeWidth="2"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const phone = ({ style }) => (
  <svg
    style={style}
    width="29px"
    height="43px"
    viewBox="0 0 29 43"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <defs>
      <rect id="path-1" x="3" y="0" width="26" height="41" rx="3" />
    </defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-1111.000000, -292.000000)">
        <g id="phone-copy" transform="translate(1111.000000, 292.000000)">
          <g id="Group-51">
            <path
              d="M3,2 L27,2 L27,40 L27,40 C27,41.6568542 25.6568542,43 24,43 L3,43 L3,43 C1.34314575,43 2.02906125e-16,41.6568542 0,40 L0,5 L0,5 C-2.02906125e-16,3.34314575 1.34314575,2 3,2 Z"
              id="Rectangle-51"
              fill="#9192C5"
            />
            <g id="Rectangle-51">
              <use fill="#B6BFF3" fillRule="evenodd" xlinkHref="#path-1" />
              <rect
                stroke="#222232"
                strokeWidth="2"
                x="4"
                y="1"
                width="24"
                height="39"
                rx="3"
              />
            </g>
            <circle
              id="Oval-10"
              stroke="#222232"
              strokeWidth="2"
              cx="16"
              cy="36"
              r="1"
            />
          </g>
          <rect
            id="Rectangle-51"
            fill="#F7F7F9"
            x="6"
            y="3"
            width="20"
            height="30"
            rx="3"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const money = ({ style }) => (
  <svg
    style={style}
    width="31px"
    height="43px"
    viewBox="0 0 31 43"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-1155.000000, -291.000000)">
        <g id="Group-27" transform="translate(1155.000000, 291.000000)">
          <path
            d="M11.1311475,42.6733333 C10.9016382,42.4555545 10.7868852,42.1755573 10.7868852,41.8333333 L10.7868852,38.5666667 C8.4917918,38.2866653 6.54099164,37.7033378 4.93442623,36.8166667 C3.32786082,35.9299956 2.11912974,34.8333399 1.30819672,33.5266667 C0.497263705,32.2199935 0.0612024918,30.8355629 0,29.3733333 C0,29.0933319 0.0994525574,28.8600009 0.298360656,28.6733333 C0.497268754,28.4866657 0.734424852,28.3933333 1.00983607,28.3933333 L7.1147541,28.3933333 C7.5125703,28.3933333 7.81857816,28.4555549 8.03278689,28.58 C8.24699561,28.7044451 8.4918019,28.9222207 8.76721311,29.2333333 C9.71585174,30.944453 11.4600966,31.8 14,31.8 C15.6524673,31.8 16.9300501,31.5433359 17.8327869,31.03 C18.7355236,30.5166641 19.1868852,29.8088934 19.1868852,28.9066667 C19.1868852,28.2533301 18.9497291,27.7166688 18.4754098,27.2966667 C18.0010905,26.8766646 17.2666716,26.503335 16.2721311,26.1766667 C15.2775907,25.8499984 13.8164031,25.4844465 11.8885246,25.08 C8.18577384,24.3333296 5.41640262,23.1977854 3.58032787,21.6733333 C1.74425311,20.1488813 0.826229508,17.9711253 0.826229508,15.14 C0.826229508,12.6199874 1.71365233,10.4811199 3.48852459,8.72333333 C5.26339685,6.96554677 7.69615941,5.86889107 10.7868852,5.43333333 L10.7868852,2.16666667 C10.7868852,1.82444273 10.9016382,1.54444553 11.1311475,1.32666667 C11.3606569,1.1088878 11.6284138,1 11.9344262,1 L15.9278689,1 C16.2644826,1 16.5398896,1.1088878 16.7540984,1.32666667 C16.9683071,1.54444553 17.0754098,1.82444273 17.0754098,2.16666667 L17.0754098,5.52666667 C19.0950921,5.90000187 20.8393369,6.56110637 22.3081967,7.51 C23.7770565,8.45889363 24.9016354,9.54777163 25.6819672,10.7766667 C26.462299,12.0055617 26.8830598,13.1955498 26.9442623,14.3466667 C26.9442623,14.6266681 26.8524599,14.8677768 26.6688525,15.07 C26.485245,15.2722232 26.2557391,15.3733333 25.9803279,15.3733333 L19.5540984,15.3733333 C18.8502697,15.3733333 18.3300563,15.0933361 17.9934426,14.5333333 C17.8098351,13.8799967 17.3278728,13.32778 16.547541,12.8766667 C15.7672092,12.4255533 14.826235,12.2 13.7245902,12.2 C12.4393378,12.2 11.4448123,12.433331 10.7409836,12.9 C10.037155,13.366669 9.6852459,14.0511066 9.6852459,14.9533333 C9.6852459,15.8555601 10.1442577,16.5633308 11.0622951,17.0766667 C11.9803325,17.5900026 13.6786761,18.1111085 16.157377,18.64 C19.0338942,19.1688915 21.3289532,19.829996 23.042623,20.6233333 C24.7562927,21.4166706 26.010925,22.443327 26.8065574,23.7033333 C27.6021898,24.9633396 28,26.5577681 28,28.4866667 C28,31.2244581 27.0131246,33.4799911 25.0393443,35.2533333 C23.0655639,37.0266755 20.4109456,38.1311089 17.0754098,38.5666667 L17.0754098,41.8333333 C17.0754098,42.1755573 16.9683071,42.4555545 16.7540984,42.6733333 C16.5398896,42.8911122 16.2644826,43 15.9278689,43 L11.9344262,43 C11.6284138,43 11.3606569,42.8911122 11.1311475,42.6733333 Z"
            id="$"
            fill="#9192C5"
          />
          <path
            d="M14.1311475,41.6733333 C13.9016382,41.4555545 13.7868852,41.1755573 13.7868852,40.8333333 L13.7868852,37.5666667 C11.4917918,37.2866653 9.54099164,36.7033378 7.93442623,35.8166667 C6.32786082,34.9299956 5.11912974,33.8333399 4.30819672,32.5266667 C3.4972637,31.2199935 3.06120249,29.8355629 3,28.3733333 C3,28.0933319 3.09945256,27.8600009 3.29836066,27.6733333 C3.49726875,27.4866657 3.73442485,27.3933333 4.00983607,27.3933333 L10.1147541,27.3933333 C10.5125703,27.3933333 10.8185782,27.4555549 11.0327869,27.58 C11.2469956,27.7044451 11.4918019,27.9222207 11.7672131,28.2333333 C12.7158517,29.944453 14.4600966,30.8 17,30.8 C18.6524673,30.8 19.9300501,30.5433359 20.8327869,30.03 C21.7355236,29.5166641 22.1868852,28.8088934 22.1868852,27.9066667 C22.1868852,27.2533301 21.9497291,26.7166688 21.4754098,26.2966667 C21.0010905,25.8766646 20.2666716,25.503335 19.2721311,25.1766667 C18.2775907,24.8499984 16.8164031,24.4844465 14.8885246,24.08 C11.1857738,23.3333296 8.41640262,22.1977854 6.58032787,20.6733333 C4.74425311,19.1488813 3.82622951,16.9711253 3.82622951,14.14 C3.82622951,11.6199874 4.71365233,9.4811199 6.48852459,7.72333333 C8.26339685,5.96554677 10.6961594,4.86889107 13.7868852,4.43333333 L13.7868852,1.16666667 C13.7868852,0.824442733 13.9016382,0.544445533 14.1311475,0.326666667 C14.3606569,0.1088878 14.6284138,0 14.9344262,0 L18.9278689,0 C19.2644826,0 19.5398896,0.1088878 19.7540984,0.326666667 C19.9683071,0.544445533 20.0754098,0.824442733 20.0754098,1.16666667 L20.0754098,4.52666667 C22.0950921,4.90000187 23.8393369,5.56110637 25.3081967,6.51 C26.7770565,7.45889363 27.9016354,8.54777163 28.6819672,9.77666667 C29.462299,11.0055617 29.8830598,12.1955498 29.9442623,13.3466667 C29.9442623,13.6266681 29.8524599,13.8677768 29.6688525,14.07 C29.485245,14.2722232 29.2557391,14.3733333 28.9803279,14.3733333 L22.5540984,14.3733333 C21.8502697,14.3733333 21.3300563,14.0933361 20.9934426,13.5333333 C20.8098351,12.8799967 20.3278728,12.32778 19.547541,11.8766667 C18.7672092,11.4255533 17.826235,11.2 16.7245902,11.2 C15.4393378,11.2 14.4448123,11.433331 13.7409836,11.9 C13.037155,12.366669 12.6852459,13.0511066 12.6852459,13.9533333 C12.6852459,14.8555601 13.1442577,15.5633308 14.0622951,16.0766667 C14.9803325,16.5900026 16.6786761,17.1111085 19.157377,17.64 C22.0338942,18.1688915 24.3289532,18.829996 26.042623,19.6233333 C27.7562927,20.4166706 29.010925,21.443327 29.8065574,22.7033333 C30.6021898,23.9633396 31,25.5577681 31,27.4866667 C31,30.2244581 30.0131246,32.4799911 28.0393443,34.2533333 C26.0655639,36.0266755 23.4109456,37.1311089 20.0754098,37.5666667 L20.0754098,40.8333333 C20.0754098,41.1755573 19.9683071,41.4555545 19.7540984,41.6733333 C19.5398896,41.8911122 19.2644826,42 18.9278689,42 L14.9344262,42 C14.6284138,42 14.3606569,41.8911122 14.1311475,41.6733333 Z"
            id="$"
            fill="#B6BFF3"
          />
          <path
            d="M11.785,27.535014 C12.7150047,29.1783462 14.4249876,30 16.915,30 C18.5350081,30 19.7874956,29.7535039 20.6725,29.2605042 C21.5575044,28.7675045 22,28.0877728 22,27.2212885 C22,26.5938344 21.7675023,26.0784334 21.3025,25.67507 C20.8374977,25.2717067 20.1175049,24.9131668 19.1425,24.5994398 C18.1674951,24.2857127 16.7350095,23.9346425 14.845,23.5462185 C11.2149819,22.8291281 8.500009,21.7385694 6.7,20.2745098 C4.899991,18.8104502 4,16.7189678 4,14 M30,13 C30,13.2608709 29.9095754,13.4855063 29.7287234,13.673913 C29.5478714,13.8623198 29.3218099,13.9565217 29.0505319,13.9565217 L22.7207447,13.9565217 C22.0274788,13.9565217 21.5150726,13.6956548 21.1835106,13.173913 C21.0026587,12.5652143 20.5279294,12.0507267 19.7593085,11.6304348 C18.9906876,11.2101428 18.0638352,11 16.9787234,11 C15.7127596,11 14.7331595,11.2173891 14.0398936,11.6521739 C13.3466277,12.0869587 13,12.7246335 13,13.5652174 C13,14.4058013 13.4521231,15.065215 14.356383,15.5434783 C15.2606428,16.0217415 16.9334984,16.5072439 19.375,17 M14,37 C11.6595628,36.725887 9.67022096,36.1548267 8.03191489,35.286802 C6.39360883,34.4187774 5.16099704,33.3451841 4.33404255,32.0659898 C3.50708806,30.7867956 3.06241166,29.4314792 3,28"
            id="$-copy"
            stroke="#222232"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const location = ({ style }) => (
  <svg
    style={style}
    width="30px"
    height="39px"
    viewBox="0 0 30 39"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-1199.000000, -294.000000)">
        <g id="Group-55" transform="translate(1199.000000, 295.000000)">
          <g id="Group-52">
            <path
              d="M12.5,33 C15.1400087,33 25,21.657294 25,13.5714286 C25,5.48556315 19.4035594,1 12.5,1 C5.59644063,1 3.86809735e-16,5.48556315 0,13.5714286 C0,21.657294 9.8599913,33 12.5,33 Z"
              id="Oval-8-Copy-3"
              fill="#9192C5"
            />
            <path
              d="M16.5,32 C19.1400087,32 29,20.657294 29,12.5714286 C29,4.48556315 23.4035594,0 16.5,0 C9.59644063,0 4,4.48556315 4,12.5714286 C4,20.657294 13.8599913,32 16.5,32 Z"
              id="Oval-8-Copy-3"
              stroke="#222232"
              strokeWidth="2"
              fill="#B6BFF3"
            />
            <circle
              id="Oval-8-Copy-6"
              fill="#F7F7F9"
              cx="14.5"
              cy="10.5"
              r="4.5"
            />
            <circle
              id="Oval-8-Copy-6"
              stroke="#222232"
              strokeWidth="2"
              cx="16.5"
              cy="9.5"
              r="4.5"
            />
          </g>
          <path
            d="M7.5,37 L25.5,37"
            id="Line-11"
            stroke="#222232"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </g>
      </g>
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/assets/FillIcons.js